module.exports = __webpack_public_path__ + "img/bmcl_gallery8.d2325a64.jpg";